<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Sale konferencyjne</h4>
              <button v-if="hasPermission('canAddConferenceRooms')" @click="addConferenceRoom"
                      class="btn btn-primary btn-sm"><i class="bi bi-plus-circle me-2"></i>Dodaj salę
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">

          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>

          <div v-if="isModalVisible" class="modal-overlay">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header d-flex justify-content-between align-items-center">
                  <h5 class="modal-title mb-0">Dodaj nową salę konferencyjną</h5>
                  <button type="button" class="btn-close" @click="cancelNewRoom"></button>
                </div>
                <div class="modal-body">
                  <form @submit.prevent="saveNewRoom">
                    <div class="mb-3">
                      <label for="roomName" class="form-label">Nazwa sali</label>
                      <input type="text" v-model="newRoom.name" id="roomName" class="form-control"/>
                    </div>
                    <div class="mb-3">
                      <label for="roomDescription" class="form-label">Opis</label>
                      <input type="text" v-model="newRoom.description" id="roomDescription" class="form-control"/>
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Działy (Edycja tylko dla)</label>
                      <Vueform>
                        <TagsElement
                            name="departments"
                            :native="false"
                            value-prop="id"
                            label-prop="name"
                            :items="departments"
                            :default="newRoom.departments_id"
                            @change="changeDepartments"
                        />
                      </Vueform>
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Kolor tła sali</label>
                      <div class="color-palette">
                        <div
                            v-for="(color, index) in colorPalette"
                            :key="'bg-'+index"
                            class="color-box"
                            :class="{ selected: newRoom.color === color }"
                            :style="{ backgroundColor: color }"
                            @click="selectColor(color, 'color')"
                        ></div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label class="form-label">Kolor tekstu (biały/czarny)</label>
                      <div class="color-palette">
                        <div
                            v-for="(color, index) in textColorPalette"
                            :key="'text-'+index"
                            class="color-box"
                            :class="{ selected: newRoom.textColor === color }"
                            :style="{ backgroundColor: color }"
                            @click="selectColor(color, 'textColor')"
                        ></div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" @click="cancelNewRoom">Anuluj</button>
                      <button type="submit" class="btn btn-primary">Zapisz</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>


          <div class="custom-table">
            <div class="table-responsive">
              <table id="conference-room-table" class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa sali</th>
                  <th>Opis</th>
                  <th>Edycja tylko dla</th>
                  <th>Kolor tła</th>
                  <th>Kolor tekstu</th>
                  <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(room, index) in rooms" :key="room.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ room.name }}</td>
                  <td>{{ room.description }}</td>
                  <td>
                    <ul>
                      <li v-for="department in roomsDepartmentMap[room.id]" :key="department.id">
                        {{ department.name }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <div
                        :style="{ backgroundColor: room.color, width: '30px', height: '30px', border: '1px solid #ccc', borderRadius: '4px' }"
                        title="Kolor tła"
                    ></div>
                  </td>
                  <td>
                    <div
                        :style="{ backgroundColor: room.textColor, width: '30px', height: '30px', border: '1px solid #ccc', borderRadius: '4px' }"
                        title="Kolor tekstu"
                    ></div>
                  </td>
                  <td class="text-nowrap">
                    <div class="d-flex gap-2">
                      <button
                          v-if="hasPermission('canAddConferenceRooms')"
                          @click="editConferenceRoom(room.id)"
                          class="btn btn-sm btn-outline-info flex-fill action-btn"
                      >
                        <i class="bi bi-pencil me-2"></i>Edytuj
                      </button>
                      <button
                          v-if="hasPermission('canAddConferenceRooms')"
                          @click="deleteConferenceRoom(room.id)"
                          class="btn btn-sm btn-danger flex-fill action-btn"
                      >
                        <i class="bi bi-trash me-2"></i>Usuń
                      </button>
                    </div>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import {useForm} from "@inertiajs/vue3";
import AppLayout from "@/Layouts/App.vue";
import {ref} from "vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import {router} from "@inertiajs/vue3";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import axios from 'axios';

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, hasPermission},
  props: {
    rooms: Array,
    departments: Array,
    roomsDepartmentMap: Object
  },
  data() {
    return {
      hasPermission,
      isModalVisible: false,
      editingId: null,
      newRoom: this.getEmptyRoom(),
      colorPalette: ['#000000', '#4c6565', '#337be8', '#5999d5', '#33FF57', '#3ddbd9', '#42c0e9', '#9dadb4', '#e84833', '#fd2602', '#FF5733', '#F0F0F0', '#3a3a3a', '#6e44ff', '#ffc107', '#ffffff', '#FF0000', '#17a60c', '#0000FF'],
      textColorPalette: ['#000000', '#FFFFFF'],
    };
  },
  methods: {
    changeDepartments(selectedDepartments) {
      this.newRoom.departments_id = selectedDepartments || [];
    },
    getEmptyRoom() {
      return {
        id: null,
        name: '',
        description: '',
        departments_id: [],
        color: '#F0F0F0',
        textColor: '#000000'
      };
    },
    addConferenceRoom() {
      this.newRoom = this.getEmptyRoom();
      this.isModalVisible = true;
    },

    editConferenceRoom(id) {

      this.newRoom = this.getEmptyRoom();

      axios.get(route('conferencerooms.edit', id))
          .then((response) => {
            if (response && response.data && response.data.room) {
              this.newRoom = {
                id: response.data.room.id,
                name: response.data.room.name,
                description: response.data.room.description,
                departments_id: response.data.roomsDepartmentMap.map(dep => dep.id),
                color: response.data.room.color,
                textColor: response.data.room.textColor,
              };

              this.changeDepartments(this.newRoom.departments_id);
              this.isModalVisible = true;
              this.editingId = id;


            } else {
              console.error("Brak danych sali w odpowiedzi:", response);
            }
          })
          .catch((error) => {
            console.error("Błąd przy ładowaniu danych sali:", error);
          });
    },

    cancelNewRoom() {
      this.isModalVisible = false;
      this.newRoom = this.getEmptyRoom();
    },
    saveNewRoom() {
      if (!this.newRoom.color) {
        this.newRoom.color = '#F0F0F0';
      }
      if (!this.newRoom.textColor) {
        this.newRoom.textColor = '#000000';
      }

      const url = this.newRoom.id
          ? route('conferencerooms.update', this.newRoom.id)
          : route('conferencerooms.addroom');

      this.$inertia.post(url, this.newRoom, {
        onSuccess: () => {
          this.isModalVisible = false;
          this.newRoom = this.getEmptyRoom();
        },
      });
    },

    deleteConferenceRoom(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie sali konferencyjnej',
        html: 'Czy na pewno chcesz usunąć wybraną salę konferencyjną?',
        showDenyButton: true,
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('conferencerooms.remove'), {
            data: {room_id: id},
            preserveScroll: true,
            onSuccess: (page) => {
              Toast.fire({
                icon: 'success',
                title: 'Sala została usunięta!',
                text: 'Usunięto również wszystkie rezerwacje powiązane z tą salą.',
              });
            },
            onError: (errors) => {
              Toast.fire({
                icon: 'error',
                title: 'Wystąpił błąd podczas usuwania sali.',
              });
            }
          });
        }
      });
    },

    selectColor(color, type) {
      this.newRoom[type] = color;
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-dialog {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-width: 600px;
}

.color-palette {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.color-box {
  width: 30px;
  height: 30px;
  border: 2px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}

.color-box.selected {
  border: 3px solid #000;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.btn-close {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
}

.btn-close:hover {
  opacity: 0.75;
}
</style>